// TODO: I think this could be a 'reMark' plugin
// (eg. see https://github.com/zeit/remark-capitalize/blob/master/index.js)

const FLAG_PATTERN = /^(IMPORTANT|HINT|WARNING|NOTE)(?: \(([^)]*)\))?:$/

const extractFlag = (el, _parent) => {
  if (el.props) return extractFlag(el.props, el)
  if (el.children && el.children.props) return extractFlag(el.children.props, el.children)
  if (el.children && el.children[0] && el.children[0].props) return extractFlag(el.children[0].props, el.children)
  if (el.mdxType === "strong" && typeof el.children === "string") {
    const m = el.children.match(FLAG_PATTERN)
    if (m) return { type: m[1].toLowerCase(), title: m[2] }
  }
  return null
}

export default extractFlag
